import React from 'react';

import Fluid from '../../Fluid';
import RelatedArticles from '../RelatedArticles';
import { Section } from '../styles';

const RecommendedArticles = ({
  relatedArticles,
  borderless = false,
  padding = 'none',
  title = 'Recommended Articles',
  subtitle,
  ctaLinkUrl
}) => {
  return (
    <Section padding="md" borderless={borderless}>
      <Fluid padding={padding}>
        <RelatedArticles
          title={title}
          imgHeight="11rem"
          relatedArticles={relatedArticles}
          subtitle={subtitle}
          ctaLinkUrl={ctaLinkUrl}
          bottom
        />
      </Fluid>
    </Section>
  );
};

export default RecommendedArticles;
